import React, { FC } from "react";
import { tailspin } from "ldrs";

export const PageLoader: FC = () => {
  tailspin.register();

  return (
    <div className="bg-slate-100/80 fixed top-0 left-0 w-full h-full flex items-center justify-center block z-[100]">
      <div className="text-base text-blue-500">Loading...</div>

      <l-tailspin size="40" stroke="5" speed="0.9" color="#434992"></l-tailspin>
    </div>
  );
};
